import { isEmpty } from 'lodash';
import { SpreadsheetConfig } from 'components/ScalarSpreadsheet/utilities/SpreadsheetConfig';
import { PERFORMANCE_METRICS_SPREADSHEET_COLUMN_KEY_PREFIX } from 'pages/Valuations/approaches/guidelinePublicCompanies/PerformanceMetrics/common/constants/performanceMetrics';
import { PERFORMANCE_METRICS_SPREADSHEET_TABLE_TERMS } from 'pages/Valuations/approaches/guidelinePublicCompanies/PerformanceMetrics/common/constants/performanceMetrics/sheetConfigs';
import {
  createColumns,
  customParser,
  rowConfig,
} from 'pages/ValuationsAllocation/approaches/TransactionComps/PerformanceMetrics/config';
import { CreatePerformanceMetricsDataParams } from 'pages/ValuationsAllocation/approaches/TransactionComps/PerformanceMetrics/types';
import { getApproachTableName } from 'pages/ValuationsAllocation/util';
import { getObjectValue } from 'utilities';

const createPerformanceMetrics = (params: CreatePerformanceMetricsDataParams) => {
  const { approach, companyName, financials } = params;

  const { valuations_approach_gpt } = getObjectValue(approach);
  const valuationsApproachGpt = getObjectValue(valuations_approach_gpt);

  // Generate Approach table name
  const name = getApproachTableName({
    approach,
    tableSuffix: PERFORMANCE_METRICS_SPREADSHEET_COLUMN_KEY_PREFIX,
  });

  // Create columns for Performance Metrics Spreadsheet
  const getColumns = () =>
    !isEmpty(valuationsApproachGpt) && !isEmpty(financials)
      ? createColumns({
        valuationsApproachGpt,
        financials,
      })
      : [];

  const columns = getColumns();

  const config = rowConfig({
    companyName,
    valuationsApproachGpt,
  });

  // Create Spreadsheet config
  return !isEmpty(columns)
    ? new SpreadsheetConfig({
      columns,
      currencyFormatter: true,
      format: undefined,
      name,
      page: PERFORMANCE_METRICS_SPREADSHEET_TABLE_TERMS.tableName as unknown as SpreadsheetConfig['page'],
      parser: customParser,
      rowConfig: config,
      showToolbar: true,
      tableData: { columns },
      tableTerms: PERFORMANCE_METRICS_SPREADSHEET_TABLE_TERMS as unknown as SpreadsheetConfig['tableTerms'],
      totalParser: undefined,
      unitsFormatter: true,
      initialObj: approach as unknown as SpreadsheetConfig['initialObj'],
      getColumns,
    })
    : undefined;
};

export default createPerformanceMetrics;
